export default __webpack_public_path__ + "media/images/Masto-C2-marguerite-6fd0aeabc773965f49ae17ad3630865b.png";